import { Button, styled } from '@mui/material';
import { buttonClasses } from '@mui/material/Button';
import {
  primaryButtonBaseStyles,
  primaryButtonHoverStyles,
  primaryButtonPseudoElementStyles
} from 'common/theme/button/sharedButtonStyles';

const StyledAppbarButtonLink = styled(Button)(({ theme }) => ({
  ...primaryButtonBaseStyles(theme),
  padding: '10px 20px',
  '&::before': {
    ...primaryButtonHoverStyles,
    ...primaryButtonPseudoElementStyles(theme)
  },
  '&:hover::before': {
    opacity: 1
  },
  [`&.${buttonClasses.disabled}`]: {
    background: theme.palette.grey[800]
  }
}));

export default StyledAppbarButtonLink;
